// Sample data for the Sales Commission Tool prototype
// Staffing/temp-agency flavored to match the BoldStaff + Sage references in the scope doc.

export const REPS = [
  { id: 'r1', name: 'Marisol Reyes',   email: 'marisol@company.com',  start: '2022-08-15', active: true },
  { id: 'r2', name: 'Devon Park',      email: 'devon@company.com',    start: '2023-02-06', active: true },
  { id: 'r3', name: 'Arjun Malhotra',  email: 'arjun@company.com',    start: '2021-11-01', active: true },
  { id: 'r4', name: 'Priya Okafor',    email: 'priya@company.com',    start: '2024-05-20', active: true },
  { id: 'r5', name: 'Kenji Alvarado',  email: 'kenji@company.com',    start: '2020-03-02', active: true },
  { id: 'r6', name: 'Sasha Lindgren',  email: 'sasha@company.com',    start: '2025-01-13', active: true },
];

export const RATES = {
  aca:  0.018,  // 1.8%
  sick: 0.012,  // 1.2%
  y1:   0.05,   // 5%
  y2:   0.07,   // 7%
};

// A handful of clients with enough variety for the tables
export const CLIENTS = [
  { id: 'c01', name: 'Meridian Logistics',       rootId: 'MERID-001', branch: 'LH', rep: 'r1', since: '2023-04', firstInvoice: '2023-04-11' },
  { id: 'c02', name: 'Northwind Industrial',     rootId: 'NWIN-014',  branch: 'LH', rep: 'r1', since: '2022-11', firstInvoice: '2022-11-02' },
  { id: 'c03', name: 'Pallet Pros LLC',          rootId: 'PPRO-007',  branch: 'LH', rep: 'r1', since: '2024-02', firstInvoice: '2024-02-19' },
  { id: 'c04', name: 'Ashford Cold Storage',     rootId: 'ACOLD-021', branch: 'PX', rep: 'r2', since: '2023-08', firstInvoice: '2023-08-07' },
  { id: 'c05', name: 'Brightline Manufacturing', rootId: 'BRITE-003', branch: 'PX', rep: 'r2', since: '2021-06', firstInvoice: '2021-06-14' },
  { id: 'c06', name: 'Cascade Recycling Co',     rootId: 'CASC-009',  branch: 'PX', rep: 'r3', since: '2022-02', firstInvoice: '2022-02-28' },
  { id: 'c07', name: 'Delmar Foods',             rootId: 'DELM-018',  branch: 'LH', rep: 'r3', since: '2024-11', firstInvoice: '2024-11-03' },
  { id: 'c08', name: 'Evercrest Packaging',      rootId: 'EVER-012',  branch: 'SA', rep: 'r3', since: '2023-01', firstInvoice: '2023-01-22' },
  { id: 'c09', name: 'Granite State Freight',    rootId: 'GSFR-005',  branch: 'SA', rep: 'r4', since: '2025-03', firstInvoice: '2025-03-10' },
  { id: 'c10', name: 'Halyard Marine Supply',    rootId: 'HALY-016',  branch: 'SA', rep: 'r4', since: '2024-09', firstInvoice: '2024-09-16' },
  { id: 'c11', name: 'Ironwood Distribution',    rootId: 'IRON-022',  branch: 'LH', rep: 'r5', since: '2020-07', firstInvoice: '2020-07-01' },
  { id: 'c12', name: 'Juniper Pallet & Crate',   rootId: 'JUNP-004',  branch: 'LH', rep: 'r5', since: '2021-09', firstInvoice: '2021-09-12' },
  { id: 'c13', name: 'Keystone Auto Parts',      rootId: 'KEYS-011',  branch: 'PX', rep: 'r5', since: '2022-12', firstInvoice: '2022-12-08' },
  { id: 'c14', name: 'Longview Warehousing',     rootId: 'LONG-019',  branch: 'SA', rep: 'r6', since: '2025-08', firstInvoice: '2025-08-14' },
  { id: 'c15', name: 'Martindale Steel',         rootId: 'MART-006',  branch: 'PX', rep: 'r6', since: '2025-11', firstInvoice: '2025-11-02' },
  // unassigned
  { id: 'c16', name: 'Quorum Fulfillment',       rootId: 'QUOR-031',  branch: 'LH', rep: null, since: null, firstInvoice: '2026-03-02' },
  { id: 'c17', name: 'Redwood Logistics Grp',    rootId: 'REDW-028',  branch: 'LH', rep: null, since: null, firstInvoice: '2026-03-04' },
  { id: 'c18', name: 'Sterling Freight Lines',   rootId: 'STER-027',  branch: 'PX', rep: null, since: null, firstInvoice: '2026-03-07' },
  { id: 'c19', name: 'Tidewater Packaging',      rootId: 'TIDE-029',  branch: 'SA', rep: null, since: null, firstInvoice: '2026-03-11' },
  { id: 'c20', name: 'Upland Food Service',      rootId: 'UPLA-030',  branch: 'LH', rep: null, since: null, firstInvoice: '2026-03-15' },
  { id: 'c21', name: 'Valiant Transport Co',     rootId: 'VALI-032',  branch: 'PX', rep: null, since: null, firstInvoice: '2026-03-18' },
  { id: 'c22', name: 'Westline Cold Chain',      rootId: 'WEST-033',  branch: 'LH', rep: null, since: null, firstInvoice: '2026-03-20' },
];

// Deterministic invoice generator: 4-8 invoices per client for March 2026 run
function seedRand(seed) {
  let s = seed;
  return () => {
    s = (s * 9301 + 49297) % 233280;
    return s / 233280;
  };
}

function genInvoices() {
  const rand = seedRand(42);
  const invoices = [];
  let idCounter = 3400;
  CLIENTS.forEach((client, idx) => {
    const count = 2 + Math.floor(rand() * 5);
    for (let i = 0; i < count; i++) {
      const totalBill   = Math.round((3200 + rand() * 18000) * 100) / 100;
      const grossWages  = Math.round(totalBill * (0.58 + rand() * 0.12) * 100) / 100;
      const gp          = Math.round((totalBill - grossWages) * 100) / 100;
      const aca         = Math.round(grossWages * RATES.aca * 100) / 100;
      const sick        = Math.round(grossWages * RATES.sick * 100) / 100;
      const net         = Math.round((gp - aca - sick) * 100) / 100;
      // rate tier: Y1 if within first 12 months of client's first invoice
      const tier        = ['c15', 'c14', 'c09', 'c07', 'c03'].includes(client.id) ? 'y1' : 'y2';
      const rate        = RATES[tier];
      const commission  = Math.round(net * rate * 100) / 100;
      const day         = 1 + Math.floor(rand() * 28);
      const paid        = rand() > 0.22;
      const ageDays     = paid ? 0 : Math.floor(rand() * 140) + 5;
      invoices.push({
        id: `inv-${++idCounter}`,
        doc: `${client.branch}-${idCounter}`,
        clientId: client.id,
        client: client.name,
        branch: client.branch,
        repId: client.rep,
        date: `2026-03-${String(day).padStart(2, '0')}`,
        totalBill, grossWages, gp, aca, sick, net, tier, rate, commission,
        paid, outstanding: paid ? 0 : Math.round(totalBill * (0.3 + rand() * 0.7) * 100) / 100,
        ageDays,
        overridden: false,
        excluded: false,
      });
    }
  });
  return invoices;
}

export const INVOICES = genInvoices();

// Runs
export const RUNS = [
  { id: 'run-2026-03', period: 'March 2026',    status: 'draft',     total: null, finalizedAt: null,      finalizedBy: null },
  { id: 'run-2026-02', period: 'February 2026', status: 'finalized', total: 48210.73, finalizedAt: '2026-03-05', finalizedBy: 'V. Israni' },
  { id: 'run-2026-01', period: 'January 2026',  status: 'finalized', total: 51987.12, finalizedAt: '2026-02-04', finalizedBy: 'V. Israni' },
  { id: 'run-2025-12', period: 'December 2025', status: 'finalized', total: 44326.58, finalizedAt: '2026-01-06', finalizedBy: 'V. Israni' },
  { id: 'run-2025-11', period: 'November 2025', status: 'finalized', total: 47015.22, finalizedAt: '2025-12-04', finalizedBy: 'V. Israni' },
  { id: 'run-2025-10', period: 'October 2025',  status: 'finalized', total: 49882.04, finalizedAt: '2025-11-05', finalizedBy: 'V. Israni' },
];

// Rep history: 12 months of commission per rep for trend chart
function genRepHistory() {
  const rand = seedRand(7);
  const months = [
    'Apr \u201925','May \u201925','Jun \u201925','Jul \u201925','Aug \u201925','Sep \u201925',
    'Oct \u201925','Nov \u201925','Dec \u201925','Jan \u201926','Feb \u201926','Mar \u201926',
  ];
  const hist = {};
  REPS.forEach((rep) => {
    const base = 5500 + rand() * 4200;
    hist[rep.id] = months.map((m, i) => ({
      month: m,
      commission: Math.round((base + i * 180 + (rand() - 0.5) * 1600) * 100) / 100,
    }));
  });
  return hist;
}

export const REP_HISTORY = genRepHistory();

// Aggregates
export function sumBy(arr, fn) { return arr.reduce((a, x) => a + fn(x), 0); }

export function getRunTotals(invoices) {
  return {
    totalBill:   sumBy(invoices, i => i.totalBill),
    gp:          sumBy(invoices, i => i.gp),
    commission:  sumBy(invoices.filter(i => !i.excluded), i => i.commission),
    unpaid:      sumBy(invoices.filter(i => !i.paid), i => i.outstanding),
    invoiceCount: invoices.length,
  };
}

export function getRepTotals(invoices, repId) {
  const rows = invoices.filter(i => i.repId === repId && !i.excluded);
  return {
    count: rows.length,
    totalBill:  sumBy(rows, i => i.totalBill),
    gp:         sumBy(rows, i => i.gp),
    commission: sumBy(rows, i => i.commission),
    unpaid:     sumBy(rows.filter(i => !i.paid), i => i.outstanding),
  };
}

// Data is exported via `export const` above — no window globals.
